import { Component, OnInit, ViewChild } from '@angular/core';
import { IMyDpOptions } from 'mydatepicker';
import { FormBuilder } from '@angular/forms';
import { SpringDatatablePagination } from '../../../shared/services/spring-integration/pagination/spring-datatable-pagination';
import { SpringDatatablePaginationService } from '../../../shared/services/spring-integration/pagination/spring-datatable-pagination.service';
import { HttpParams } from '@angular/common/http';
import { DateUtilService } from '../../../shared/services/date-util.service';
import { Router } from '@angular/router';
import { NotificationsService } from 'angular2-notifications';
import { DatatableService } from '../../../shared/services/datatable.service';
import { DatatableComponent, DataTablePagerComponent } from '@swimlane/ngx-datatable';
import { AprovacaoPixService } from './aprovacao-pix.service';
import { NbDialogService } from '@nebular/theme';
import { ModalAprovarPixComponent } from './modal-aprovar-pix/modal-aprovar-pix.component';
import { DocumentoHelper } from '../../../shared/utils/documento.helper';

@Component({
  selector: 'ngx-aprovacao-pix',
  templateUrl: './aprovacao-pix.component.html',
  styleUrls: ['./aprovacao-pix.component.scss']
})
export class AprovacaoPixComponent implements OnInit {

  @ViewChild('myTable', null)
  private myTable: DatatableComponent

  @ViewChild('tablePager', null)
  public tablePager: DataTablePagerComponent;

  public formAprovacaoPix = null;
  public extrato = null;
  public rowData = null;
  public tableLimit = 12;
  public listTipoConta = null;
  public listTipoOperacao = null;
  public cnpjCpf = null;
  public customLogin = null;

  datatablePagination: SpringDatatablePagination = new SpringDatatablePagination()

  myDatePickerOptions: IMyDpOptions = {
    dateFormat: 'dd/mm/yyyy',
    showClearDateBtn: false,
    openSelectorOnInputClick: true,
    showTodayBtn: false,
    allowSelectionOnlyInCurrentMonth: false,
    dayLabels: { su: "Dom", mo: "Seg", tu: "Ter", we: "Qua", th: "Qui", fr: "Sex", sa: "Sab" },
    monthLabels: { 1: "Jan", 2: "Fev", 3: "Mar", 4: "Abr", 5: "Mai", 6: "Jun", 7: "Jul", 8: "Ago", 9: "Set", 10: "Out", 11: "Nov", 12: "Dez" },
    firstDayOfWeek: "su",

  };

  constructor(
    private formBuilder: FormBuilder,
    private paginationService: SpringDatatablePaginationService,
    private service: AprovacaoPixService,
    private dateUtilService: DateUtilService,
    private router: Router,
    private notificationService: NotificationsService,
    private datatableService: DatatableService,
    private dialogService: NbDialogService,
  ) {

    this.paginationService.setDatatablePagination(this.datatablePagination);

    this.listTipoConta = [
      {
        tipoConta: 'TOP_PESSOA',
        descricao: 'Top Pessoa'
      },
      {
        tipoConta: 'TOP_EMPRESA',
        descricao: 'Top Empresa'
      },

    ];

    this.listTipoOperacao = [
      {
        statusSolicitacao: 'AGUARDANDO_AVALIACAO',
        descricao: 'Aguardando Avaliação'
      },
      {
        statusSolicitacao: 'APROVADA',
        descricao: 'Aprovada'
      },
      {
        statusSolicitacao: 'REJEITADA',
        descricao: 'Rejeitada'
      },

    ];

  }

  listaAprovacaoPix(data?: any, page?: string) {

    let params = new HttpParams();

    if (page) {
      params = params.append('page', String(page));
    }

    params = params.append('size', String(this.tableLimit))

    if(data != undefined){

      if (data.tipoConta != null) {
        params = params.append('tipoConta', data.tipoConta)
      }
      if (data.identificador != null && String(data.identificador).trim() !== '') {
        params = params.append('identificador', this.normalizarCnpjCpfParaBackend(data.identificador));
      }
      if (data.dataInicio != null) {
        let dataInicio = this.dateUtilService.datepickerTransformDate(data.dataInicio, 'YYYY-MM-DD');
        params = params.append('dataInicio', dataInicio)
      }
      if (data.dataFim != null) {
        let dataFim: any = this.dateUtilService.datepickerTransformDate(data.dataFim, 'YYYY-MM-DD');
        params = params.append('dataFim', dataFim)
      }
      if (data.statusSolicitacao != null) {
        params = params.append('statusSolicitacao', data.statusSolicitacao)
      }

    }

      this.service.aprovacaoPix(params, (response => {

        this.extrato = response.content.length;
        this.paginationService.setInfo(response)

        if (this.extrato == 0) {
          this.notificationService.warn('Não há dados nesse período!');
        }

      }), null);
  }

  ngOnInit() {

    let resCustom = localStorage.getItem('bway-customLogin');
    this.customLogin = JSON.parse(resCustom);
    document.title = this.customLogin.title;
    this.datatableService.subscribeTable(this.myTable);
    this.listaAprovacaoPix();
    this.formAprovacaoPix = this.formBuilder.group({
      dataInicio: [null],
      dataFim: [null],
      tipoConta: [null],
      identificador: [null],
      statusSolicitacao: [null]
    });

  }

  getCpfCnpjMask(): string {
    return DocumentoHelper.getMascaraCpfCnpj(this.cnpjCpf);
  }

  formatarDocumento(valor: string | null | undefined): string {
    return DocumentoHelper.formatarDocumento(valor);
  }

  private normalizarCnpjCpfParaBackend(value: any): string {
    if (value == null) return '';
    const str = String(value);
    if (str === '') return '';
    const tipo = DocumentoHelper.detectarTipoDocumento(str);
    return DocumentoHelper.normalizarParaEnvio(str, tipo);
  }

  previousPage() {
    this.router.navigate(['/iot-dashboard']);
  }

  gotoAprovacao(data: any) {

    this.dialogService.open(ModalAprovarPixComponent, {
      context: {
        id: data.id,
        nomeSolicitante: data.nomeSolicitante,
        cpfCnpj: data.cpfCnpj,
        valorAntigo: data.valorAntigo,
        valorNovo: data.valorNovo,
      },
    })

  }

  gotoLimpar() {

    this.cnpjCpf = null;
    this.formAprovacaoPix.controls['tipoConta'].setValue(null);
    this.formAprovacaoPix.controls['identificador'].setValue(null);
    this.formAprovacaoPix.controls['statusSolicitacao'].setValue(null);
    this.formAprovacaoPix.controls['dataInicio'].setValue(null);
    this.formAprovacaoPix.controls['dataFim'].setValue(null);
    this.datatablePagination.rowData = [];
    this.datatablePagination.currentPage = 0;
    this.datatablePagination.totalPages = 0;
    this.datatablePagination.totalElements = 0;
    this.datatablePagination.tableLimit = 0;

  }

  getButtonPrimaria() {
    if (this.customLogin != null) {
      return this.customLogin.primaria;
    }
  }

  getButtonSecundaria() {
    if (this.customLogin != null) {
      return this.customLogin.secundaria;
    }
  }

  getButtonTerciario() {
    if (this.customLogin != null) {
      return this.customLogin.terciario;
    }
  }

}
